<template>
  <div class="activity-banner" :style="{ alignItems: alignItems, maxWidth: maxWidth, maxHeight: maxHeight }" @click.stop="bannerClicked(playingBanner)" v-if="playingBanner.material">
    <img
      class="banner-img"
      :class="{ 'fade-in': isFading }"
      :src="!isMobile ? playingBanner.material : playingBanner.format"
      :style="{ maxWidth: maxWidth, maxHeight: maxHeight, borderBottomLeftRadius: borderRadius, borderBottomRightRadius: borderRadius }" />
  </div>
</template>

<script>
import api from '@/services/api';

let cycleCompleted = false;
let cycleCounter = 0;
let randIndex = 0;

export default {
  name: 'Banner',
  props: {
    bannerSlot: {
      type: String,
    },
    bannerOverwrite: {
      type: Object,
    },
    alignItems: {
      type: String,
      default: 'center',
    },
    maxWidth: {
      type: String,
      default: '100%',
    },
    maxHeight: {
      type: String,
      default: '100px',
    },
    borderRadius: {
      type: String,
      default: 'none',
    },
  },

  data() {
    return {
      bannerLifetime: 10000,
      banners: [],
      isFading: false,
      playlistInterval: null,
      playingBanner: {},
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 1080;
    },
  },
  methods: {
    getApiBanner() {
      let bannerQuery = '';
      switch (this.bannerSlot) {
        case 'social_top_banner':
          bannerQuery = `?tag=social_top_banner`;
          break;
        case 'video_gallery_top_banner':
          bannerQuery = `?tag=video_gallery_top_banner`;
          break;
        case 'multi_gallery_top_banner':
          bannerQuery = `?tag=multi_gallery_top_banner`;
          break;
        case 'cards_top_banner':
          bannerQuery = `?tag=cards_top_banner`;
          break;
        case 'network_top_banner':
          bannerQuery = `?tag=network_top_banner`;
          break;
        case 'profile_bottom_banner':
          bannerQuery = `?tag=profile_bottom_banner`;
          break;
        case 'login_bottom_banner':
          bannerQuery = `?tag=login_bottom_banner`;
          break;
        case 'live_stage_banner':
          bannerQuery = `?tag=live_stage_banner`;
          break;
        case 'live_video_banner':
          bannerQuery = `?tag=live_video_banner`;
          break;
        case 'live_side_banner_a':
          bannerQuery = `?tag=live_side_banner_a`;
          break;
        case 'live_side_banner_b':
          bannerQuery = `?tag=live_side_banner_b`;
          break;
        default:
          bannerQuery = '';
      }
      api
        .get(`event/${this.$store.state.eventId}/banner${bannerQuery}`)
        .then((response) => {
          // console.log('Banner get beforeMount: ', { response });
          this.banners = response.data.filter((org) => org.material.length);

          let tempBanners = [];
          this.banners.map((org) => {
            org.material.map((banner) => tempBanners.push(banner));
          });

          this.banners = [];
          this.banners = tempBanners;

          if (this.banners.length > 1) {
            this.startPlaylist();
          } else if (this.banners.length == 1) {
            this.isFading = true;
            this.playingBanner = this.banners[0];
            setTimeout(() => (this.isFading = false), 2000);
            this.$emit('enableBanner');
            this.notifyBannerAction('impression');
          } else this.$emit('disableBanner');
        })
        .catch((error) => {
          this.$emit('disableBanner');
          console.error(error);
        });
    },
    startPlaylist() {
      this.$emit('enableBanner');

      randIndex = Math.floor(Math.random() * this.banners.length);
      // console.log('startPlaylist', randIndex);
      this.isFading = true;
      this.playingBanner = this.banners[randIndex];
      this.notifyBannerAction('Impression');
      setTimeout(() => (this.isFading = false), 2000);
      this.playlistInterval = setInterval(() => {
        randIndex++;
        if (randIndex == this.banners.length) randIndex = 0;
        this.isFading = true;
        this.playingBanner = this.banners[randIndex];
        setTimeout(() => (this.isFading = false), 2000);
        cycleCounter++;
        if (cycleCounter == this.banners.length) cycleCompleted = true;
        cycleCompleted ? '' : this.notifyBannerAction('Impression');
      }, this.bannerLifetime);
    },

    bannerClicked(banner) {
      this.$nextTick(() => {
        // console.log('bannerClicked:', { banner });
        this.notifyBannerAction('Click');
        if (banner.html) window.open(banner.html);
      });
    },
    notifyBannerAction(actionType) {
      this.playingBanner.originRoute = this.$route.name;
      let payload = {
        action: actionType,
        banner_id: this.playingBanner.banner_id,
        organization_id: this.playingBanner.organization_id,
        properties: JSON.stringify(this.playingBanner),
      };
      if (this.bannerSlot != 'login_bottom_banner') {
        api
          .post(`event/${this.$store.state.eventId}/bannerAction`, payload)
          .then((response) => {
            // console.log('notifyBannerAction: ', { response });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    onWindowResize() {
      this.$nextTick(() => {
        this.windowWidth = window.innerWidth;
        // console.log('resized', window.innerWidth);
      });
    },
  },
  beforeMount() {
    if (this.bannerOverwrite) this.playingBanner = this.bannerOverwrite;
    else this.getApiBanner();
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.bannerLifetime = this.$store.state.template.banners ? this.$store.state.template.banners.bannerLifetime : this.bannerLifetime;
    // this.bannerLoop();
  },
  beforeDestroy() {
    clearInterval(this.playlistInterval);
    window.removeEventListener('resize', this.onWindowResize);
  },
};
</script>

<style lang="scss" scoped>
.activity-banner {
  cursor: pointer;
  position: relative;
  // margin-top: 20px;
  flex-grow: 1;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @include media('<=phone-plus') {
    max-width: 100%;
  }
}
.banner-img {
  cursor: pointer;
  object-fit: contain;
  object-position: top;
  // max-width: 100%;
}
.fade-in {
  opacity: 1;
  animation-name: fadeInOpacity;
  // animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 1s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
